import PropTypes from 'prop-types';
import { useMemo } from 'react';

import { ReactSelectAsyncWithAxios } from '@hivebrite/design-system/Inputs';

const noOptionsMessage = ({ inputValue }) =>
  inputValue
    ? __('User %{user} not found').i__({
        user: inputValue,
      })
    : __('Search for a user');

const ReactSelectUsers = ({
  admin,
  placeholder,
  inputValue,
  searchType,
  isMulti,
  multiple,
  ...otherProps
}) => {
  const loadOptionsUrl = useMemo(
    () =>
      Routes[
        admin
          ? 'quick_search_backoffice_networks_path'
          : 'quick_search_users_path'
      ]({
        params: {
          format: 'js',
          sort_by: 'lastname',
          term: inputValue,
          ...(searchType && { search_type: searchType }),
        },
      }),
    [admin, inputValue, searchType],
  );

  return (
    <ReactSelectAsyncWithAxios
      {...otherProps}
      multiple={multiple || isMulti}
      headers={{
        'X-Requested-With': 'XMLHttpRequest',
      }}
      loadOptionsUrl={loadOptionsUrl}
      placeholder={placeholder || __('User')}
      noOptionsMessage={noOptionsMessage}
    />
  );
};

ReactSelectUsers.propTypes = {
  admin: PropTypes.bool,
  searchType: PropTypes.string,
  placeholder: PropTypes.string,
};

export default ReactSelectUsers;
